import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import {
    getDisplayName,
    formatPhoneNumber,
    formatDocument, maskPhone,
} from "../../utils/usersUtils";
import Pagination from "../../components/layout/Pagination";
import {getAllUsers} from "../../services/userService";

const PageHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

const Title = styled.h1`
    color: ${({ theme }) => theme.colors.primary};
`;

const ActionButton = styled.button`
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.primary};
    color: white;
    cursor: pointer;
`;

const TabsContainer = styled.div`
    display: flex;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
`;

const TabButton = styled.button`
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    background: none;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    ${({ active }) =>
        active &&
        `
    font-weight: bold;
    color: #800020;
    border-bottom: 3px solid #800020;
  `}
`;

const SearchInput = styled.input`
    width: 100%;
    max-width: 400px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 20px;
`;

const TableWrapper = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    overflow-x: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    th,
    td {
        padding: 12px 15px;
        text-align: left;
        border-bottom: 1px solid #f1f1f1;
    }

    th {
        font-weight: bold;
        color: #800020;
    }
`;

// const UsersList = ({ users, searchTerm, navigate, activeTab }) => {
//     const handleRowClick = (userId) => {
//         navigate(`/admin/usuarios/editar/${userId}`);
//     };

//     const filteredUsers = useMemo(
//         () =>
//             Array.isArray(users)
//                 ? users.filter(
//                       (user) =>
//                           getDisplayName(user)
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase()) ||
//                           (user.cpf || user.cnpj || "").includes(searchTerm)
//                   )
//                 : [],
//         [users, searchTerm]
//     );

//     const isClientTab = activeTab === "clients";

//     return (
//         <TableWrapper>
//             <StyledTable>
//                 <thead>
//                     <tr>
//                         {/* A coluna de nome muda o título para ser mais genérica */}
//                         <th>{isClientTab ? "Nome / Razão Social" : "Nome"}</th>
//                         <th>Telefone</th>
//                         {/* A coluna de CPF/CNPJ só aparece na aba de clientes */}
//                         {isClientTab && <th>CPF / CNPJ</th>}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {filteredUsers.map((user) => (
//                         <tr
//                             key={user.id}
//                             onClick={() => handleRowClick(user.id)}
//                             style={{ cursor: "pointer" }}
//                         >
//                             <td>{getDisplayName(user)}</td>
//                             <td>
//                                 {formatPhoneNumber(user.phoneNumber) || "N/A"}
//                             </td>
//                             {isClientTab && (
//                                 <td>
//                                     {formatDocument(user.cpf || user.cnpj)}
//                                 </td>
//                             )}
//                         </tr>
//                     ))}
//                 </tbody>
//             </StyledTable>
//         </TableWrapper>
//     );
// };

const UsersList = ({ users, navigate, activeTab }) => {
    const handleRowClick = (userId) => {
        navigate(`/admin/usuarios/editar/${userId}`);
    };

    const isClientTab = activeTab === "clients";

    return (
        <TableWrapper>
            <StyledTable>
                <thead>
                    <tr>
                        <th>{isClientTab ? "Nome / Razão Social" : "Nome"}</th>
                        <th>Telefone</th>
                        {isClientTab && <th>CPF / CNPJ</th>}
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr
                            key={user.id}
                            onClick={() => handleRowClick(user.id)}
                            style={{ cursor: "pointer" }}
                        >
                            <td>{getDisplayName(user)}</td>
                            <td>
                                {maskPhone(user.phoneNumber) || "N/A"}
                            </td>
                            {isClientTab && (
                                <td>
                                    {formatDocument(user.cpf || user.cnpj)}
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </StyledTable>
        </TableWrapper>
    );
};

const UsersPage = () => {
    const navigate = useNavigate();
    // 1. O estado agora armazena uma única lista de usuarios
    const [allUsers, setAllUsers] = useState([]);
    const [activeTab, setActiveTab] = useState("clients");
    const [activeTabName, setActiveTabName] = useState("Clientes");
    const [searchTerm, setSearchTerm] = useState("");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        console.log("teste")
        setCurrentPage(1);
    }, [searchTerm]);

    useEffect(() => {
        console.log("oii")
        const fetchUsers = async () => {
            try {
                // NOVO: Lógica de fetch de dados com async/await e tratamento de erro
                const data = await getAllUsers();
                console.log("data")
                setAllUsers(data);
            } catch (err) {
                console.error("Erro ao carregar usuarios:", err);
                setError("Falha ao carregar dados. Tente novamente.");
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // 2. A lógica de filtro agora acontece sobre a mesma lista 'allUsers'
    const clients = allUsers.filter(
        (u) => u.userType === "PF" || u.userType === "PJ"
    );
    const employees = allUsers.filter((u) => u.userType === "F");
    const admins = allUsers.filter((u) => u.userType === "A");

    // const renderList = () => {
    //     if (loading) return <p>Carregando...</p>;
    //     if (error) return <p style={{ color: "red" }}>{error}</p>;

    //     let usersToShow = [];
    //     switch (activeTab) {
    //         case "clients":
    //             usersToShow = clients;
    //             break;
    //         case "employees":
    //             usersToShow = employees;
    //             break;
    //         case "admins":
    //             usersToShow = admins;
    //             break;
    //         default:
    //             break;
    //     }

    //     return (
    //         <UsersList
    //             users={usersToShow}
    //             searchTerm={searchTerm}
    //             navigate={navigate}
    //             activeTab={activeTab}
    //         />
    //     );
    // };

    const renderList = () => {
        if (loading) return <p>Carregando...</p>;
        if (error) return <p style={{ color: "red" }}>{error}</p>;

        let usersToShow = [];
        switch (activeTab) {
            case "clients":
                usersToShow = clients;
                break;
            case "employees":
                usersToShow = employees;
                break;
            case "admins":
                usersToShow = admins;
                break;
            default:
                break;
        }

        const filteredUsers = usersToShow.filter(
            (user) =>
                getDisplayName(user)
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()) ||
                (user.cpf || user.cnpj || "").includes(searchTerm)
        );

        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentUsers = filteredUsers.slice(
            indexOfFirstItem,
            indexOfLastItem
        );

        return (
            <>
                <UsersList
                    users={currentUsers}
                    navigate={navigate}
                    activeTab={activeTab}
                />
                <Pagination
                    totalItems={filteredUsers.length}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                />
            </>
        );
    };

    return (
        <div>
            <PageHeader>
                <Title>Usuários</Title>
                <ActionButton onClick={() => navigate("/admin/usuarios/novo")}>
                    Novo Usuário
                </ActionButton>
            </PageHeader>

            <TabsContainer>
                <TabButton
                    active={activeTab === "clients"}
                    onClick={() => {
                        setActiveTab("clients");
                        setActiveTabName("clientes");
                        setCurrentPage(1);
                    }}
                >
                    Clientes
                </TabButton>
                <TabButton
                    active={activeTab === "employees"}
                    onClick={() => {
                        setActiveTab("employees");
                        setActiveTabName("funcionários");
                        setCurrentPage(1);
                    }}
                >
                    Funcionários
                </TabButton>
                <TabButton
                    active={activeTab === "admins"}
                    onClick={() => {
                        setActiveTab("admins");
                        setActiveTabName("administradores");
                        setCurrentPage(1);
                    }}
                >
                    Administradores
                </TabButton>
            </TabsContainer>

            <SearchInput
                type="text"
                placeholder={`Pesquisar em ${activeTabName}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            {renderList()}
        </div>
    );
};

export default UsersPage;
